export const allowedEmpIdsForIL1 = [
  //dev
  "300954", // pd
  "300381", // sourcing

  //production
  // "300282", // karthik pd
  "300321", // karthik VS pd
  "300088", // prathiraj
  // "300246", // Subramaniam T


  "300420", ///prabhu
  // "300454", ///sivakumar m
  "300106", //Prabhakaran K
// "300225", ///sivaraj
"300669", ///nandkumar
"300182", ///govind /////pd

"300740", ///kuppuraj
"300197", ///seva
// "300680", ///vishal ///soucring
"300639",//RAJARAM KULANTHAIVEL

];



export const allowedEmpIdsFor2b2 = [
  //dev
  "300954", // pd


  //production
  // "300282", // karthik pd
  "300321", // karthik VS pd

];

export const allowedEmpIdsForIL2 = [
  // 'HTL_0039',
  "300954",
  // "300757",
  // "300458",
  // "300371",
  // "300381",
  // "HTL_0039",
  // "300549",
  // "FL_0004", // eno
  // "FL_0005", //ho
  // "FL_0006", //bus

  ///prodection

  "300665", //Neeraja Kota 	Manufacturing Ennore
  // "300368", //Baskaran N   Manufacturing Hosur
  "300016", //parthiban    Manufacturing Hosur
  // "300623", //	Kesavan.S   Manufacturing Bus Body
  "300450", //	Kesavan.S   Manufacturing Bus Body

  // "300282", // karthik pd
  "300321", // karthik VS pd
  "300158", // Kalidasan A Quality
  "300539", // Manoj George CJ Commercial Marketing
  // "300345", //	Chelladurai P  Finance
  // "300522", //Kaushik Raj sourcing
  "300503", //vijayapandi finance
  "300088", //prathivi sourcing
    "300321", // karthik VS pd
];





export const iL1ReassignEmpIds = [

//dev
  // "HTL_0039",
  // "300381",
  // "HTL_0062",
  // "300549",

//production

// "300360",
// "300321",
// "300454",  //pd

// "300088",
// "300740",
// "300197",  //sourcing


// "300420", ///prabhu
// "300225", ///sivaraj
// "300182", ///govind /////pd

// "300740", ///kuppuraj
// "300197", ///seva
// "300680", ///vishal ///soucring



];


export const adminEmpIds = [
  
  //dev
  "300381",
  "300954",

//production
"300321",//KarthickVS
"300522", ///Kaushik Raj sourcing
"300355", //vignesh manikandan
"300618", /// Jeeva
"300499", ///sathguru
"300088", /// prathivi
"300379", //// Ashok Kumar
"300896",/// Karthick s1
"300300", /// Pradeep C
"300106"///prabhakaran

];


export const sourcingEmpIds = [

  // dev
  "300757",
  "300381",
  // "HTL_0062",
  // "EL_0003",
  // prd
  "300088",
  "300740", ///kuppuraj
"300197", ///seva
// "300680", ///vishal ///soucring
"300639",///RAJARAM KULANTHAIVEL



];
// export const sourcingEmpIds = ["300757", "300549"];



export const il4EmpIds = [
  /// dev
  "300381",
  "300954" ,
  
 /// prd 
  // "300282",
  "300321", // karthik VS pd
  "300158"

];




export const il5EmpIds = [
  /// dev
  // "300381",  // checked by
  "300954" ,   // preparedby
  "300381", // approved by
  
 /// prd 
"300088", /// checked and prepared
"300503"/// appproved

];



export const il2ViewAccess = [
"300164", ///Murugesan K	
	"300512", ///Sunil Kumar Reddy
"300388", ///Ashok Pradap S
	"300360", ///Harishkumar P  
"300558",
];